import _useMount from 'react-use/esm/useMount';
import {notify} from '@gemcook/notification';

import constants from '@constants';
import api from '@api';
import utils from '@utils';

export const useMount = (
  me: MeStore,
  planDetail: any,
  setUsersCount: React.Dispatch<React.SetStateAction<number>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setCardInfo: any
) => {
  _useMount(async () => {
    try {
      const qp: UsersGetUsersCountQueryParams = {
        teamId: me.teamId,
      };

      const [usersCount, cardInfo] = await Promise.all([
        api.users.getUsersCount(qp),
        utils.stripe.getCardInfo(me.customerId),
      ]);

      setUsersCount(usersCount.count);
      setCardInfo(cardInfo);
    } catch (error) {
      notify(constants.ERRORS.UNKNWON, 'error');
    } finally {
      setLoading(false);
    }
  });
};
